import { Attendee } from '../../types/event/attendee';

export const attendeeService = {
    getEventAttendees: async (eventUuid: string): Promise<Attendee[]> => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/tickets/event/${eventUuid}/attendees`, {
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error('Failed to fetch attendees');
        }

        return response.json();
    },

    reissueTicket: async (ticketUuid: string, newEmail: string): Promise<void> => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/tickets/reissue/${ticketUuid}`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ newEmail })
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Failed to reissue ticket');
        }
    },

    refundTicket: async (ticketUuid: string): Promise<{ ok: boolean, message: string }> => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/tickets/refund/${ticketUuid}`, {
            method: "POST",
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ uuid: ticketUuid })
        });

        if (!response.ok) {
            const error = await response.json();
            return {ok: false, message: error.message || 'Failed to refund'};
        }
        else {
            const responseJson = await response.json();
            return {ok: true, message: responseJson.message};
        }
    }
}; 